'use strict';

var variables = require('./variables-1eb6495a.js');
var colorManipulator = require('./colorManipulator-abc93889.js');

// No type for now as this is part of lab and the types
// aren't compatible with the core override types.
// These overrides need some work as well
const light = {
    inputRoot: {
        boxSizing: "border-box",
        borderRadius: variables.SIZES.BORDER_RADIUS,
        "&&": {
            padding: 0,
        },
        "&&& input": {
            padding: "8px 4px",
        },
        "&&& $endAdornment": {
            right: 4,
        },
    },
    listbox: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    option: {
        height: "48px",
        '&[data-focus="true"]': {
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
        },
    },
    endAdornment: {
        top: "auto",
        bottom: "4px",
        position: "absolute",
    },
    popupIndicator: {
        borderRadius: variables.SIZES.BORDER_RADIUS,
        border: `solid 1px ${variables.COLORS.GREYSCALE_0_15}`,
        color: variables.COLORS.GREYSCALE_0_60,
        marginRight: 0,
        width: variables.SIZES.TEXT_EXTRA_LARGE,
        height: variables.SIZES.TEXT_EXTRA_LARGE,
        "& svg": {
            fontSize: "0.7em",
        },
        "& i": {
            lineHeight: "1 !important",
        },
    },
    paper: {
        marginTop: "5px",
        boxShadow: `0px 2px 4px 0px ${variables.COLORS.GREYSCALE_0_15}`,
    },
    clearIndicator: {
        "& svg": {
            fontSize: "0.5em",
            position: "absolute",
        },
        color: variables.COLORS.GREYSCALE_25,
        width: variables.SIZES.TEXT_LARGE,
        height: variables.SIZES.TEXT_EXTRA_LARGE,
        borderRadius: variables.SIZES.BORDER_RADIUS,
        backgroundColor: "unset",
        marginRight: "4px",
        // Need more specificity here to override the IconButton override
        "&&&&:hover": {
            backgroundColor: colorManipulator.alpha(variables.COLORS.GREYSCALE_0, 0.05),
        },
    },
    popupIndicatorOpen: {
        backgroundColor: variables.COLORS.GREYSCALE_0_10,
    },
};

var MuiAutocomplete = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiAutocomplete = MuiAutocomplete;
exports.light = light;
